<template>
  <div>
    <slot name="before" :rlist="self"></slot>
    <div :class="classContent" class>
      <slot name="beforeInner" :rlist="self"></slot>

      <div class="infinite-scroll-content virtual-list-parent full-height">
        <f7-list virtual-list :virtual-list-params="vlParams" ref="vl" :class="getClasses()">
          <table v-if="tableMode" class="width-100">
            <slot name="header" :rlist="self"></slot>
            <tbody class="ptr-content">
              <div class="ptr-preloader" style="position:absolute;">
                <div class="preloader"></div>
                <div class="ptr-arrow"></div>
              </div>
              <tr colspan="100%" :style="`height:${vlData.topPosition}px`"></tr>
              <slot :vlData="vlData" :rlist="self"></slot>
              <tr
                :style="`height:${vlData.listHeight-vlData.topPosition-(vlData.toIndex-vlData.fromIndex)*vlParams.height}px`"
              >
                <td colspan="100%" style="height:0px;padding:0!important;">
                  <div
                    v-show="loadingInfinite && !loadingPtr"
                    class="preloader infinite-scroll-preloader"
                  ></div>
                </td>
              </tr>
            </tbody>
            <slot name="footer" :rlist="self"></slot>
          </table>

          <template v-else>
            <slot name="header" :rlist="self"></slot>
            <div class="ptr-preloader">
              <div class="preloader"></div>
              <div class="ptr-arrow"></div>
            </div>
            <ul class="ptr-content">
              <div :style="`height:${vlData.topPosition}px`"></div>
              <slot :vlData="vlData" :rlist="self"></slot>
              <div
                :style="`height:${vlData.listHeight-vlData.topPosition-(vlData.toIndex-vlData.fromIndex)*vlParams.height}px`"
              >
                <div
                  v-show="loadingInfinite && !loadingPtr"
                  class="preloader infinite-scroll-preloader"
                ></div>
              </div>
            </ul>
          </template>
          <slot v-if="!loadingPtr&&!loadingInfinite&&!vlData.items.length" name="empty"></slot>
        </f7-list>
      </div>
      <slot name="afterInner" :rlist="self"></slot>
    </div>
    <slot name="after" :rlist="self"></slot>
  </div>
</template>
<script>
export default {
  data() {
    var data = this.items;
    var vlParams = {
      ...{
        //el: ".virtual-list",
        items: data,
        renderExternal: this.renderExternal,
        searchAll: this.searchAll,
        setListHeight: false,
        updatableScroll: false,
        scrollableParentEl: ".virtual-list-parent",
        createUl: false,
        cache: false,
        rowsBefore: 60,
        rowsAfter: 60,
        height: this.$theme.ios ? 44 : this.$theme.md ? 48 : 38
      },
      ...this.virtualListParams
    };

    return {
      self: this,
      selected: {},
      count: 0,
      nomore: false,
      page: 1,
      order: this.sort,
      orderDir: this.sortDir,
      conditions: this.filter,
      //data: data,
      _jqxhr: null,
      loadingInfinite: false,
      loadingPtr: false,
      vlData: {
        items: []
      },
      vlParams: vlParams
    }; // FALTA: virtualListParams como prop y altura automática para parent
  },
  props: {
    classContent: {},
    classList: {},
    dbAdapter: {
      type: Object
    },
    rowsPerPage: {
      type: Number,
      default: 60
    },
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    virtualListParams: {
      type: Object,
      default() {
        return {};
      }
    },
    primary: {
      type: String,
      default: "id"
    },
    sort: {
      type: String,
      default: ""
    },
    sortDir: {
      type: String,
      default: "ASC"
    },
    tableMode: {
      type: Boolean,
      default: false
    },
    infiniteScroll: {
      type: Boolean,
      default: true
    },
    complete: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  mounted() {
    var self = this;
    var app = self.$f7;

    var $content = self.$$(self.$el).find(".ptr-content");
    var $infinite_content = self.$$(self.$el).find(".infinite-scroll-content");
    app.ptr.create($content[0]);
    app.infiniteScroll.create($infinite_content[0]);

    if (self.dbAdapter) {
      $content.on("ptr:refresh", function(e) {
        if (self.loadingPtr) return;
        self.initRemoteData();
      });
      if (self.infiniteScroll) {
        $infinite_content.on("infinite", function() {
          if (self.loadingInfinite || self.nomore) return;
          self.page = self.page + 1;
          self.getRemoteData();
        });
      }
      self.refresh();
    }
  },
  methods: {
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    toggleSelect: function(data, value) {
      var self = this;
      if (typeof data[self.primary] == "undefined") return;
      if (value) {
        self.$set(self.selected, data[self.primary], data);
      } else {
        self.$delete(self.selected, data[self.primary]);
      }
      self.$emit("select", Object.assign({}, self.selected));
    },
    toggleSelectAll: function(value) {
      var self = this;
      if (value) {
        self.$refs.vl.f7VirtualList.items.forEach(function(data) {
          self.$set(self.selected, data[self.primary], data);
        });
      } else {
        self.selected = {};
      }
    },
    paramsGetRemoteData: function() {
      var self = this;
      return {
        filter: self.conditions,
        limit: self.rowsPerPage == -1 ? null : self.rowsPerPage,
        offset:
          self.rowsPerPage == -1 ? null : self.rowsPerPage * (self.page - 1),
        page: self.page,
        order: self.order,
        orderDir: self.orderDir,
        complete: self.complete
      };
    },
    getRemoteData: function() {
      var self = this;
      var app = self.$f7;
      var $content = self.$$(self.$el).find(".ptr-content");
      self.loadingInfinite = true;
      var params = self.paramsGetRemoteData();
      self.dbAdapter
        .getList(params)
        .then(function(res) {
          if (!res.list.length && parseInt(res.totalCount)) {
            self.page = self.page - 1;
            self.nomore = true;
          } else {
            self.load(res.list);
          }
          self.count = res.totalCount;
          self.$emit("load");
        })
        .catch(function(e) {
          if (typeof e == "string") e = { error: e };
          let error = e.error || e.error_description;
          app.toast
            .create({
              text: error,
              position: "center",
              closeTimeout: 2000
            })
            .open();
          self.page = self.page - 1;
          self.nomore = true;
        })
        .finally(function() {
          app.ptr.done($content);
          self.loadingInfinite = false;
          self.loadingPtr = false;
        });
    },
    refresh: function() {
      var self = this;
      var app = self.$f7;
      var $content = self.$$(self.$el).find(".ptr-content");
      app.ptr.refresh($content);
    },
    exportExcel: function(name) {
      var self = this;
      var app = self.$f7;
      var params = self.paramsGetRemoteData();
      params.name = name;
      app.preloader.show();
      self.dbAdapter.exportExcel(params).finally(_ => app.preloader.hide());
    },
    initRemoteData: function() {
      var self = this;
      self.page = 1;
      self.nomore = false;
      self.clearData();
      if (self._jqxhr) self._jqxhr.abort();
      self.loadingPtr = true;
      self.getRemoteData();
    },
    load: function(data) {
      var self = this;
      self.addData(data);
    },
    addData: function(data) {
      var self = this;
      self.$refs.vl.f7VirtualList.appendItems(data);
      self.count = data.length;
    },
    clearData: function() {
      var self = this;
      self.$refs.vl.f7VirtualList.deleteAllItems();
      self.count = 0;
    },
    setOrder: function(order) {
      var self = this;
      var app = self.$f7;
      self.order = order;
      if (self.orderDir == "DESC") {
        self.orderDir = "ASC";
      } else {
        self.orderDir = "DESC";
      }
      self.refresh();
    },
    setFilter: function(filter) {
      var self = this;
      var app = self.$f7;
      self.conditions = filter;
      //self.initRemoteData();
      self.refresh();
    },
    deleteItem: function(id) {
      var self = this;
      var app = self.$f7;
      self.$f7.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          self.dbAdapter
            .delete({ itemId: id })
            .then(function(res) {
              if (res) {
                app.toast
                  .create({
                    icon: '<i class="f7-icons">checkmark</i>',
                    text: self.$t("rlist.registro_eliminado"),
                    position: "center",
                    destroyOnClose: true,
                    closeTimeout: 2000
                  })
                  .open();
                self.removeItem(id);
                self.$emit("deleteItem");
              }
            })
            .catch(function(error) {
              app.dialog.alert(error.message);
            });
        }
      );
    },
    removeItem: function(id) {
      var self = this;
      let idx = self.$refs.vl.f7VirtualList.items.findIndex(
        d => d[self.primary] == id
      );
      self.$refs.vl.f7VirtualList.deleteItem(idx);
    },
    sortableClasses: function(field) {
      var rlist = this;
      return {
        "label-cell": true,
        "sortable-cell": true,
        "sortable-cell-active": rlist.order == field,
        "sortable-desc": rlist.orderDir == "DESC",
        "sortable-asc": rlist.orderDir == "ASC"
      };
    },
    getClasses: function() {
      var self = this;
      var classes = Object.assign([], self.classList);
      if (true) {
        // Si no hay acciones masivas sobre la tabla
        classes.push("hidden-checkboxes");
      }
      return classes;
    }
  }
};
</script>
<style>
.ptr-content {
  overflow: visible !important;
}
.full-height {
  display: flex;
  flex-flow: column;
  height: 100% !important;
}

.thead-sticky tr:last-child > * {
  top: 0;
}
.tfoot-sticky tr:first-child > * {
  bottom: 0;
}
.tfoot-sticky tr > *,
.thead-sticky tr > * {
  position: -webkit-sticky !important;
  position: sticky !important;
  opacity: 1;
  z-index: 16;
  background: #fff;
}
.left-column-sticky {
  left: 0;
}
.right-column-sticky {
  right: 0;
}
.left-column-sticky,
.right-column-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
  opacity: 1;
  z-index: 17 !important;
  background: #f7f7f8;
}

.thead-sticky tr > *.left-column-sticky,
.thead-sticky tr > *.right-column-sticky {
  z-index: 18 !important;
}
.virtual-list-parent {
  overflow: auto;
}

td,
th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.infinite-scroll-content {
  overflow-x: auto;
}

.hidden-checkboxes .checkbox { 
  visibility: hidden;
}
</style>
